<template>
  <div
    class="no-data-box inner_center">

    <div class="no-data-img"/>
    <div class="no-data-info">
      <div class="title">抱歉，没有找到符合条件的素材</div>
      <div class="no-data-text">您可以尝试：
        <span> • 检查拼写 • 使用同义词或通用术语</span>
        <!--                  或者也可以向-->
      </div>
      <div
        @click="navTo"
        class="text-fankui" >提交素材建议</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PicPackageEmptyList",
  methods:{
    navTo(){
      this.$emit('navTo')
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data-box {
  //width: 100%;
  text-align: center;
  padding: 118px 0 168px;

  .no-data-img {
    width: 186px;
    height: 198px;
    @include BgImage(186px, 198px, 'material/empty.png');
  }

  .no-data-info {
    //height: 20px;
    font-size: 14px;
    color: rgba(0, 16, 19, 0.65);
    line-height: 20px;

    .title {
      font-size: 18px;
      color: #001013;
      line-height: 24px;
      margin: 32px 0 10px;
    }

    .no-data-text {
      color: rgba(0, 16, 19, 0.5);

      span {
        color: rgba(0, 16, 19, 0.65);
      }


    }

    .text-fankui {
      display: inline-block;
      background-color: $color-primary;
      color: #FFFFFF;
      //width: 144px;
      padding: 0 30px;
      border-radius: 8px;
      font-size: 14px;
      line-height: 44px;
      margin-top: 24px;
      cursor: pointer;
    }
  }
}
</style>
